"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var react_1 = __importDefault(require("react"));
var app_1 = require("../app");
var error_message_1 = __importDefault(require("../components/error_message"));
var localization_1 = require("../localization");
var payment_1 = require("../steps/payment");
var useContext = react_1.default.useContext, useState = react_1.default.useState, useEffect = react_1.default.useEffect, useMemo = react_1.default.useMemo;
var useOptions = function () {
    var options = useMemo(function () {
        return {
            classes: {
                base: 'checkout-hosted-payment-field',
                invalid: 'checkout-hosted-payment-field--invalid',
                focus: 'checkout-hosted-payment-field--focus',
            },
            style: {
                base: {
                    borderRadius: '4px',
                    border: '2px solid #f1f1f1',
                    // 'padding': '1.25em 0.5em',
                    color: '#0a0a0a',
                    letterSpacing: '0.025em',
                    fontFamily: 'Oakes Grotesk", sans-serif',
                    '::placeholder': {
                        color: '#aab7c4',
                    },
                    // },
                    // invalid: {
                    //   color: "#9e2146"
                    // }
                },
            },
        };
    }, []);
    return options;
};
exports.default = (function () {
    var context = useContext(app_1.CheckoutContext);
    var paymentContext = useContext(payment_1.PaymentContext);
    if (!context || !paymentContext)
        return null;
    var billingAddress = context.billingAddress, customer = context.customer, setPaymentInfo = context.setPaymentInfo, setPaymentValid = context.setPaymentValid, email = context.email;
    var setCCTokenizer = paymentContext.setCCTokenizer;
    var _a = __read(useState(null), 2), ccNumberError = _a[0], setCCNumberError = _a[1];
    var _b = __read(useState(null), 2), ccExpiryError = _b[0], setCCExpiryError = _b[1];
    var _c = __read(useState(null), 2), ccCVCError = _c[0], setCVCError = _c[1];
    var stripe = (0, react_stripe_js_1.useStripe)();
    var elements = (0, react_stripe_js_1.useElements)();
    var options = useOptions();
    var tokenizePayment = function (strp, elmt) {
        return function (bAddress) { return __awaiter(void 0, void 0, void 0, function () {
            var card, payload, pm, paymentInformation;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        //  bAddress is taken in as a parameter and not through the context.
                        // The way the tokenizer is dynamically set up, billing address is not available in the execution scope.
                        if (!strp || !elmt) {
                            return [2 /*return*/];
                        }
                        card = elmt.getElement(react_stripe_js_1.CardNumberElement);
                        if (!card) {
                            throw new Error('There was a problem getting access to card');
                        }
                        return [4 /*yield*/, strp.createPaymentMethod({
                                type: 'card',
                                card: card,
                                billing_details: {
                                    email: email,
                                    phone: bAddress === null || bAddress === void 0 ? void 0 : bAddress.phoneNumber,
                                    name: "".concat(bAddress === null || bAddress === void 0 ? void 0 : bAddress.firstName, " ").concat(bAddress === null || bAddress === void 0 ? void 0 : bAddress.lastName),
                                    address: {
                                        line1: bAddress === null || bAddress === void 0 ? void 0 : bAddress.address1,
                                        line2: bAddress === null || bAddress === void 0 ? void 0 : bAddress.address2,
                                        state: bAddress === null || bAddress === void 0 ? void 0 : bAddress.state,
                                        city: bAddress === null || bAddress === void 0 ? void 0 : bAddress.city,
                                        postal_code: bAddress === null || bAddress === void 0 ? void 0 : bAddress.zip,
                                        country: localization_1.CountryToCodeMapping[(bAddress === null || bAddress === void 0 ? void 0 : bAddress.country) || 'United States'],
                                    },
                                },
                            })];
                    case 1:
                        payload = _e.sent();
                        if (payload && payload.paymentMethod) {
                            pm = payload.paymentMethod;
                            paymentInformation = {
                                token: pm.id,
                                cardType: ((_a = pm.card) === null || _a === void 0 ? void 0 : _a.brand) || '',
                                expiry: "".concat((_b = pm.card) === null || _b === void 0 ? void 0 : _b.exp_month, "/").concat((_c = pm.card) === null || _c === void 0 ? void 0 : _c.exp_year),
                                last4: ((_d = pm.card) === null || _d === void 0 ? void 0 : _d.last4) || '',
                            };
                            setPaymentInfo(paymentInformation);
                            return [2 /*return*/, paymentInformation];
                        }
                        if (payload && payload.error) {
                            setPaymentInfo(undefined);
                            console.error(payload.error.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    };
    var setPaymentValidity = function () {
        if (ccExpiryError || ccNumberError || ccCVCError) {
            setPaymentValid(false);
        }
        else {
            setPaymentValid(true);
        }
    };
    var onCardNumberChange = function (event) {
        if (event.error) {
            setCCNumberError(event.error.message);
        }
        else {
            setCCNumberError(null);
        }
        setPaymentValidity();
    };
    var onCardExpiryChange = function (event) {
        if (event.error) {
            setCCExpiryError(event.error.message);
        }
        else {
            setCCExpiryError(null);
        }
        setPaymentValidity();
    };
    var onCardCVCChange = function (event) {
        if (event.error) {
            setCVCError(event.error.message);
        }
        else {
            setCVCError(null);
        }
        setPaymentValidity();
    };
    useEffect(function () {
        if (stripe && elements) {
            // console.debug('setting up tokenizer', stripe, elements)
            setCCTokenizer(function () { return tokenizePayment(stripe, elements); });
        }
        return;
    }, [stripe, elements]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'grid-x' },
            react_1.default.createElement("div", { className: 'small-12 cell' },
                react_1.default.createElement("label", null,
                    "Card Number",
                    react_1.default.createElement(react_stripe_js_1.CardNumberElement, { options: options, onChange: onCardNumberChange }),
                    react_1.default.createElement(error_message_1.default, { error: { message: ccNumberError || '' } })))),
        react_1.default.createElement("div", { className: 'grid-x grid-padding-x' },
            react_1.default.createElement("div", { className: 'small-6 cell' },
                react_1.default.createElement("label", null,
                    "Expiration",
                    react_1.default.createElement(react_stripe_js_1.CardExpiryElement, { options: options, onChange: onCardExpiryChange }),
                    react_1.default.createElement(error_message_1.default, { error: { message: ccExpiryError || '' } }))),
            react_1.default.createElement("div", { className: 'small-6 cell' },
                react_1.default.createElement("label", null,
                    "CVV",
                    react_1.default.createElement(react_stripe_js_1.CardCvcElement, { options: options, onChange: onCardCVCChange }),
                    react_1.default.createElement(error_message_1.default, { error: { message: ccCVCError || '' } }))))));
});
